// Recognise the video links people paste into the page builder.
// A hero background plays either an uploaded file (<video>) or a YouTube /
// Vimeo link (an iframe in "background" mode); anything else can't play.

const YOUTUBE_PATTERNS = [
  /(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/))([A-Za-z0-9_-]{11})/,
  /youtu\.be\/([A-Za-z0-9_-]{11})/,
];
const VIMEO_PATTERN = /vimeo\.com\/(?:video\/|channels\/[^/]+\/|groups\/[^/]+\/videos\/)?(\d+)/;
const VIDEO_FILE_PATTERN = /\.(mp4|webm)(?:[?#].*)?$/i;

export function parseVideoUrl(url) {
  const value = (url || '').trim();
  if (!value) return null;
  for (const pattern of YOUTUBE_PATTERNS) {
    const m = value.match(pattern);
    if (m) return { kind: 'youtube', id: m[1] };
  }
  const vimeo = value.match(VIMEO_PATTERN);
  if (vimeo) return { kind: 'vimeo', id: vimeo[1] };
  if (VIDEO_FILE_PATTERN.test(value) || value.startsWith('/uploads/')) {
    return { kind: 'file', url: value };
  }
  return { kind: 'unknown', url: value };
}

// Muted, looping, chrome-free player for a hero background. Browsers only
// autoplay muted video, so background embeds are always muted.
export function backgroundEmbedUrl(video, { loop = true } = {}) {
  if (!video) return null;
  if (video.kind === 'youtube') {
    const params = new URLSearchParams({
      autoplay: '1', mute: '1', controls: '0', playsinline: '1',
      rel: '0', modestbranding: '1', disablekb: '1', iv_load_policy: '3',
    });
    // YouTube only loops a single video when it is also its own playlist.
    if (loop) {
      params.set('loop', '1');
      params.set('playlist', video.id);
    }
    return `https://www.youtube-nocookie.com/embed/${video.id}?${params}`;
  }
  if (video.kind === 'vimeo') {
    return `https://player.vimeo.com/video/${video.id}?background=1&loop=${loop ? 1 : 0}`;
  }
  return null;
}

// Normal player with controls, for the Video Embed section.
export function playerEmbedUrl(url) {
  const video = parseVideoUrl(url);
  if (!video) return null;
  if (video.kind === 'youtube') return `https://www.youtube.com/embed/${video.id}`;
  if (video.kind === 'vimeo') return `https://player.vimeo.com/video/${video.id}`;
  return video.url;
}

export function youtubeThumbnail(video) {
  return video?.kind === 'youtube' ? `https://img.youtube.com/vi/${video.id}/hqdefault.jpg` : null;
}
